import React, { PropTypes } from 'react';

class FetchDataComponent extends React.Component {
  static propTypes = {
    club_id: PropTypes.string,
    list: PropTypes.array.isRequired,
    items: PropTypes.object,
    fetch: PropTypes.func.isRequired,
    fetchMore: PropTypes.func.isRequired,
    filter: PropTypes.object.isRequired,
    hasMore: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    updateHeaderTitle: PropTypes.func.isRequired
  };

  componentWillMount() {
    let {fetch, filter, headerTitle, updateHeaderTitle} = this.props;

    fetch(Object.assign({}, filter));

    if (headerTitle) {
      updateHeaderTitle(headerTitle);
    }
  }

  componentWillUnmount() {
    let {headerTitle, updateHeaderTitle} = this.props;

    if (headerTitle) {
      updateHeaderTitle();
    }
  }

  loadMore() {
    let {fetchMore, filter} = this.props;
    return Promise.resolve(fetchMore(filter));
  }

  render() {
    return (
      <div>
          {this.props.children}
      </div>
    );
  }
}

export default FetchDataComponent;



// WEBPACK FOOTER //
// ./src/components/common/FetchDataComponent.js